import { appInsightEvents, language } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { getCurrentLocalTime } from "common/date-utils";
export const handleInsInlineMenuItemClick = (ev) => {
    if (ev.detail && ev.detail.element) {
        const dataMenuItem = ev.detail.element;
        if (dataMenuItem && dataMenuItem.action) {
            dataMenuItem.action(ev);
            if (dataMenuItem.label === language.en.dashboard.settingsMenu.setBenchmark) {
                appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.ClickedOnBenchmarkAssignment, properties: { LocalTimestamp: getCurrentLocalTime() } });
            }
        }
    }
};
